module.exports = __webpack_public_path__ + "static/img/irole.08e125f.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/bz/irole.png
// module id = WW/H
// module chunks = 7